// msal-instance.factory.ts
import { Configuration, BrowserCacheLocation, LogLevel, PublicClientApplication } from '@azure/msal-browser';
import { RuntimeConfigService } from './_shared/services/config/runtime-config.service';
export function MSALInstanceFactory(runtimeConfigService: RuntimeConfigService): PublicClientApplication {
  // assume your runtime config returns an object with an 'entraAuth' property
  // that contains clientId, authority, redirectUri, and postLogoutRedirectUri values
  const runtimeConfig = runtimeConfigService.config;
  

  const msalConfig: Configuration = {
    auth: {
      clientId: runtimeConfig.shiftSSOClientId,
      authority: runtimeConfig.shiftSSOAuthority,
      redirectUri: `${window.location.origin}/login-entra-callback`,
      postLogoutRedirectUri: `${window.location.origin}`,
      navigateToLoginRequestUrl: false
    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: false
    },
    system: {
      loggerOptions: {
        loggerCallback: (logLevel, message, containsPii) => {
          console.log(message);
        },
        logLevel: LogLevel.Verbose,
        piiLoggingEnabled: false
      }
    }
  };

  return new PublicClientApplication(msalConfig);
}